export default __webpack_public_path__ + "media/images/flags/ms-60c91632b9940b03f13cf9d81310d715.png";